// callbackQueue is a utility for dealing with the pattern of exposing a
// pushable callback queue on the window as a way to decouple interactions
// between asynchronous libraries.
//
// See the Bootscripts readme for a usage example.
'use strict';
const performanceMeasure = require('./performanceMeasure.js');

function install(varName, api) {
    let measure = performanceMeasure(`callbackQueue.install:${varName}`);
    // Snag any pre-existing queue of functions that was added before
    // we started running.
    var queue = window[varName];

    // Replace the initial queue with a method that immediately executes
    // the given callback.
    /* global window */
    window[varName] = {
        push: exec,
    };

    // Process the init queue before we return
    if (queue !== undefined) {
        for (var i = 0; i < queue.length; i++) {
            exec(queue[i]);
        }
    }

    function exec(func) {
        if (api.then) {
            // this is a promise
            api.then(function (realApi) {
                api = realApi;
                func.call(api);
            });
        } else {
            func.call(api);
        }
    }

    measure.end();
}

module.exports = install;
